'use client'

import { useRequest } from '@/hooks/use-request'
import { useMutation } from '@tanstack/react-query'
import { setCookie } from 'cookies-next'
import { useRouter } from 'next/navigation'
import { z } from 'zod'

const loginSchema = z.object({
  email: z.string().email(),
  password: z.string(),
})

export function useLoginMutation() {
  const router = useRouter()

  return useMutation({
    mutationFn: async (data: { email: string, password: string }) =>
      useRequest().post('auth/login', loginSchema.parse(data)),
    onSuccess: async ({ data: { data } }) => {
      await setCookie('revpay-token', data.token)
      await setCookie('revpay-merchant', JSON.stringify(data?.merchant))

      if (!data?.merchant?.email_verified) {
        router.push('/verify-account')
        return
      }

      router.push('/dashboard')
    },
  })
}
